"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayIcon = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PlayIcon = ({
  circleSize = _constants.DEFAULT_CIRCLE_SIZE,
  className,
  isInteractive,
  playSize = _constants.DEFAULT_PLAY_SIZE,
  testId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": testId ?? getTestId(_constants.PLAY_ICON),
    circleSize: circleSize,
    isInteractive: isInteractive,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Play, {
      playSize: playSize
    })
  });
};
exports.PlayIcon = PlayIcon;
